// Permission gate voor "Klant inlichten" knop.
// Zichtbaar voor:
//  - gebruikers die via rollenbeheer toegang hebben tot Orders Decoprof
//  - admin/management volgens dezelfde check die elders in het project wordt gebruikt
// Voor overige gebruikers rendert de knop niet.
//
// Later eenvoudig uitbreidbaar naar extra rollen: voeg ze hieronder toe.
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { usePermissions } from "@/context/PermissionsContext";

export const useKlantInlichtenPermission = (): boolean => {
  const { isAuthenticated, user } = useAuth();
  const { hasPermission, isLoading } = usePermissions();

  const hasDecoprofOrdersAccess = hasPermission("ordersDecoprof", "read");
  const allowed = isLoading ? true : Boolean(isAuthenticated && hasDecoprofOrdersAccess);

  useEffect(() => {
    if (!import.meta.env.DEV) return;

    console.log("[useKlantInlichtenPermission]", {
      isLoading,
      isAuthenticated,
      hasDecoprofOrdersAccess,
      role: user?.role ?? null,
    });
  }, [hasDecoprofOrdersAccess, isAuthenticated, isLoading, user]);

  return allowed;
};
